import { convertInchesToTwip } from 'docx';

// Tokens
import theme from '../../tokens';

// Utils
import {
  convertPtToHalfPt,
  convertPtToTwip,
  convertHexToDocx,
  convertLineHeight,
} from '@/components/template/resume/utils/converters';

export const FONT_FAMILY = theme.typography.fontFamily;

/** Docx-compatible hex colors from AgilityIO design tokens */
export const COLORS = {
  foreground: convertHexToDocx(theme.colors.foreground),
  primary: convertHexToDocx(theme.colors.primary),
  secondary: convertHexToDocx(theme.colors.secondary),
  muted: convertHexToDocx(theme.colors.muted),
} as const;

/** Font sizes in half-pt (docx unit) derived from theme tokens */
export const FONT_SIZE = {
  base: convertPtToHalfPt(theme.typography.fontSize.base),
  lg: convertPtToHalfPt(theme.typography.fontSize.lg),
  '4xl': convertPtToHalfPt(theme.typography.fontSize['4xl']),
} as const;

/** US Letter page size in twips */
export const US_LETTER = {
  width: convertInchesToTwip(8.5),
  height: convertInchesToTwip(11),
} as const;

/** Logo dimensions in px */
export const LOGO_WIDTH_PX = 85;
export const LOGO_HEIGHT_PX = 22;

/** Line spacing in 240ths of a line where 240 equals single-spaced in Word */
export const LINE_SPACING = convertLineHeight(theme.typography.lineHeight);

/** Pre-computed spacing in twips from theme tokens */
export const SPACINGS = {
  sectionHeadingGap: convertPtToTwip(theme.spacing.sectionHeadingGap),
  sectionGap: convertPtToTwip(theme.spacing.sectionGap),
  listIndent: convertPtToTwip(theme.spacing.listIndent),
  displayMarginTop: convertPtToTwip(theme.spacing.displayMarginTop),
  displayMarginBottom: convertPtToTwip(theme.spacing.displayMarginBottom),
  entryTitleMarginTop: convertPtToTwip(theme.spacing.entryTitleMarginTop),
  pagePadding: convertPtToTwip(theme.spacing.pagePadding),
} as const;
